export const required = (value: any) =>
  value || typeof value === 'number' ? undefined : '*Required';

export const maxLength = (max: number) => (value: string) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = (min: number) => (value: string) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const number = (value: string) =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const minValue = (min: number) => (value: number) =>
  value && value < min ? `Must be at least ${min}` : undefined;

export const maxValue = (max: number) => (value: number) =>
  value && value > max ? `Must be at most ${max}` : undefined;

export const email = (value: string) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;

export const alphaNumeric = (value: string) =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined;

export const phoneNumber = (value: string) =>
  value && (!/^(0|[1-9][0-9]{9})$/i.test(value) && !/^[(][0-9][0-9][0-9][)][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]/g.test(value))
    ? 'Invalid phone number, must be 10 digits'
    : undefined;

export const match = (matchName: any) => (value: any, allValues: any) =>
  value !== allValues[matchName]
    ? `This field must match with ${matchName} field`
    : undefined;


export const validDateRegex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
export const validMonthDateRegex = /^(0[1-9]|1[0-2])\/(19|2[0-1])\d{2}$/;